<template>
  <b-form-group>
    <b-form-input
      v-model="dataItem.pageLink"
      readonly
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'PageLink',
  components: {
    BFormGroup, BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['qrcodes/dataItem']
    },
  },
}
</script>
